import { render, staticRenderFns } from "./DocUploadSuccess.vue?vue&type=template&id=2ce418a6&scoped=true&"
import script from "./DocUploadSuccess.vue?vue&type=script&lang=js&"
export * from "./DocUploadSuccess.vue?vue&type=script&lang=js&"
import style0 from "./DocUploadSuccess.vue?vue&type=style&index=0&id=2ce418a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce418a6",
  null
  
)

export default component.exports